export enum RoleType {
    BusinessUnitAdministrator,
    SuperAdministrator
}
